import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Atom = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M11.9997 12.09V11.9998M20.9624 20.9625C19.0667 22.8582 13.5173 20.3822 8.5674 15.4324C3.6175 10.4825 1.14159 4.933 3.03729 3.03729C4.933 1.14159 10.4825 3.6175 15.4323 8.5674C20.3822 13.5173 22.8582 19.0667 20.9624 20.9625ZM3.03749 20.9625C1.14178 19.0668 3.61769 13.5173 8.56759 8.56745C13.5175 3.61756 19.0669 1.14165 20.9626 3.03735C22.8583 4.93306 20.3824 10.4825 15.4325 15.4324C10.4826 20.3823 4.93319 22.8582 3.03749 20.9625Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
})

export default Atom
